
import { apiBaseUrl } from 'yxt-biz-pc/packages/api';

/**
 * AI提取考核点
 */
export const generatePoint = (data) => {
  return apiBaseUrl.post('/aiassist/ote/ai/generate/point', data);
};
/**
 * AI提取考核点状态
 */
export const generatePointStatus = (targetId) => {
  return apiBaseUrl.get(`/aiassist/ote/ai/generate/point/process/${targetId}`);
};
/**
 * AI提取考核点停止
 */
export const generatePointStop = (targetId) => {
  return apiBaseUrl.put(`/aiassist/ote/ai/generate/point/stop/${targetId}`);
};

/**
 * AI出题
 */
export const generateQues = (data) => {
  return apiBaseUrl.post('/aiassist/ote/ai/generate/ques', data);
};
/**
 * AI直接通过内容出题
 */
export const generateQuesDirect = (data) => {
  return apiBaseUrl.post('/aiassist/ote/ai/generate/ques/direct', data);
};

/**
 * AI出题状态
 */
export const generateQuesStatus = (targetId) => {
  return apiBaseUrl.get(`/aiassist/ote/ai/generate/ques/process/${targetId}`);
};
/**
 * AI出题停止
 */
export const generateQuesStop = (targetId) => {
  return apiBaseUrl.put(`/aiassist/ote/ai/generate/ques/stop/${targetId}`);
};
